import { ColumnSortType, TableColumnTypes } from '../../../../model/table.model';

export const tableHeaders = [
  {
    value: 'primary',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.CHECKBOX,
    className: 'table-checkbox'
  },
  {
    value: 'id',
    sort: ColumnSortType.NONE,
    name: 'ID',
    type: TableColumnTypes.TEXT_COPY,
    className: 'table-header',
    disabled: true,
  },
  {
    value: 'images',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.OLX_IMAGE,
    className: 'table-header',
    disabled: true,
  },
  {
    value: 'title',
    sort: ColumnSortType.NONE,
    name: 'name',
    type: TableColumnTypes.TITLE,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'description',
    sort: ColumnSortType.NONE,
    name: 'description',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'status',
    sort: ColumnSortType.NONE,
    name: 'status',
    type: TableColumnTypes.OLX_ADVERT_STATUS,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'price_value',
    sort: ColumnSortType.NONE,
    name: 'price',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'contact_name',
    sort: ColumnSortType.NONE,
    name: 'contact',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'full_location',
    sort: ColumnSortType.NONE,
    name: 'city',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'contact_phone',
    sort: ColumnSortType.NONE,
    name: 'contact_phone',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'url',
    sort: ColumnSortType.NONE,
    name: 'link',
    type: TableColumnTypes.LINK,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'type',
    sort: ColumnSortType.NONE,
    name: 'type',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'created_at',
    sort: ColumnSortType.NONE,
    name: 'created_at',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'valid_to',
    sort: ColumnSortType.NONE,
    name: 'valid_to',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'planned_count',
    sort: ColumnSortType.NONE,
    name: 'planned_activations',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        { icon: 'schedule', label: 'to_plan', value: 'PLANNER', color_icon: 'gray' },
        { icon: 'toggle_on', label: 'activate_now', value: 'ACTIVE_NOW', color_icon: 'green' },
        { icon: 'toggle_off', label: 'deactivate_now', value: 'DEACTIVATE_NOW', color_icon: 'red' },
        { icon: 'vertical_align_top', label: 'move_up_list', value: 'PUSH_UP', color_icon: 'green' },
        { icon: 'edit', label: 'change_price', value: 'CHANGE_PRICE', color_icon: 'gray' },
        // { icon: 'edit', label: 'change', value: 'CHANGE', color_icon: 'gray' },
        { icon: 'difference', label: 'duplicate', value: 'DUPLICATION_ADVERT', color_icon: 'gray' },
        { icon: 'delete', label: 'delete', value: 'DELETE_ADVERT', color_icon: 'red' },
        // { icon: 'paid', label: 'Рекламувати', value: 'PAID', color_icon: 'blue' },
      ],
    translate: true,
  },
];
